// LayoutContent.tsx
import React from 'react'
import {Layout} from 'antd'
import classNames from 'classnames'

import {Theme} from '@/constants'
import {NotificationDisplayTypeEnum, NotificationStatusEnum} from '@/stores/notification/types'
import {MobileAppStoresRedirect} from '@/components/composite/MobileAppStoresRedirect/MobileAppStoresRedirect'
import {
    BannerNotification,
    BlockNotification,
    PopupNotification
} from '@/components/composite/notifications'
import {Burger, Header} from '@/layouts/MainLayout/components'
import {ErrorBoundaryWrapper} from '@/components/containers/ErrorBoundaryWrapper'
import {Logo} from '@/components/composite/Logo'
import {useLocation} from 'react-router-dom'

import styles from './styles.scss'
import {ROUTES} from '@/router/routes'

const {Content} = Layout

export interface LayoutContentProps {
    children: React.ReactNode
    theme?: Theme
    isMobile: boolean
    currentSectionNotification: any
    isSectionNotificationClosed: boolean
    onCloseSectionNotification: (notificationId: any) => void
    popupNotification: any
    isPopupNotificationClosed: boolean
    onClosePopupNotification: (notificationId: string) => void
    setCollapsed: (collapsed: boolean) => void
    showMobileAppRedirect?: boolean
}

export const LayoutContent: React.FC<LayoutContentProps> = ({
    children,
    theme,
    isMobile,
    currentSectionNotification,
    isSectionNotificationClosed,
    onCloseSectionNotification,
    popupNotification,
    isPopupNotificationClosed,
    onClosePopupNotification,
    setCollapsed,
    showMobileAppRedirect = false
}) => {
    const location = useLocation()
    const isOnboarding = location.pathname.includes(ROUTES.onboarding.base)

    const renderHeaderMobile = () => (
        <Header isMobile={true}>
            <Burger onClick={() => setCollapsed(false)} />
            {isOnboarding && <Logo type={Theme.LIGHT} className={styles.mobileHeaderLogo} />}
        </Header>
    )

    return (
        <Layout className={classNames({[styles.layoutLight]: theme === Theme.LIGHT})}>
            {showMobileAppRedirect && <MobileAppStoresRedirect />}

            {isMobile ? renderHeaderMobile() : <Header />}
            {currentSectionNotification &&
            currentSectionNotification.notificationDisplayTypeId ===
                NotificationDisplayTypeEnum.BANNER &&
            !isSectionNotificationClosed ? (
                <div className={styles.bannerNotificationContainer}>
                    <BannerNotification
                        notification={currentSectionNotification}
                        onCloseNotification={onCloseSectionNotification}
                    />
                </div>
            ) : null}
            <Content>
                {currentSectionNotification &&
                currentSectionNotification.notificationDisplayTypeId ===
                    NotificationDisplayTypeEnum.BLOCK &&
                currentSectionNotification.statusId === NotificationStatusEnum.ACTIVE ? (
                    <BlockNotification notification={currentSectionNotification} />
                ) : (
                    <ErrorBoundaryWrapper>{children}</ErrorBoundaryWrapper>
                )}
            </Content>
            {popupNotification && !isPopupNotificationClosed && (
                <PopupNotification
                    notification={popupNotification}
                    onCloseNotification={onClosePopupNotification}
                />
            )}
        </Layout>
    )
}
